console.log("✅ popup-gallery.js loaded (FINAL v9: lock slide + center)");

(() => {
  const log = (...a) => console.log("[QV-V9]", ...a);

  function getDrawer() {
    return (
      document.querySelector("#Product-Drawer.side-panel.product-drawer.active") ||
      document.querySelector("#Product-Drawer.product-drawer.active") ||
      document.querySelector(".product-drawer.active") ||
      null
    );
  }

  function getVariantId(drawer) {
    const el =
      drawer?.querySelector("variant-selects input[name='id']") ||
      drawer?.querySelector("input[name='id']");
    return el?.value ? String(el.value) : null;
  }

  // /variants/<id>.js
  const vcache = new Map();
  async function fetchVariant(variantId) {
    if (vcache.has(variantId)) return vcache.get(variantId);
    const r = await fetch(`/variants/${variantId}.js`, { credentials: "same-origin" });
    if (!r.ok) throw new Error("variant fetch fail");
    const v = await r.json();
    vcache.set(variantId, v);
    return v;
  }

  function getScope(drawer) {
    return (
      drawer.querySelector(".product-quick-images") ||
      drawer.querySelector("[id*='MediaGallery']") ||
      drawer
    );
  }

  function getLargeImgs(drawer) {
    const scope = getScope(drawer);
    const imgs = [...scope.querySelectorAll("img")];
    return imgs.filter(img => {
      const r = img.getBoundingClientRect();
      return r.width >= 140 && r.height >= 140; // thumb değil
    });
  }

  // ✅ Kaymayı durdur: track/scroll/drag her şeyi kilitle
  function lockSlide(drawer) {
    if (drawer.dataset.qvLocked === "1") return;
    drawer.dataset.qvLocked = "1";

    const scope = getScope(drawer);

    // 1) Wheel ile yatay kaymayı engelle
    scope.addEventListener(
      "wheel",
      (e) => {
        if (Math.abs(e.deltaX) > 0) {
          e.preventDefault();
        }
      },
      { passive: false }
    );

    // 2) Touch ile yatay swipe engelle
    let sx = 0, sy = 0;
    scope.addEventListener(
      "touchstart",
      (e) => {
        const t = e.touches?.[0];
        if (!t) return;
        sx = t.clientX;
        sy = t.clientY;
      },
      { passive: true }
    );

    scope.addEventListener(
      "touchmove",
      (e) => {
        const t = e.touches?.[0];
        if (!t) return;
        const dx = t.clientX - sx;
        const dy = t.clientY - sy;
        if (Math.abs(dx) > Math.abs(dy)) {
          e.preventDefault();
        }
      },
      { passive: false }
    );

    // 3) Yatay scroll yapan elementleri sıfırla + kilitle
    const killHorizontal = () => {
      const els = [scope, ...scope.querySelectorAll("*")];
      els.forEach((el) => {
        try {
          if (el.scrollWidth > el.clientWidth + 5) {
            el.scrollLeft = 0;
            el.style.overflowX = "hidden";
            el.style.scrollSnapType = "none";
          }
        } catch (_) {}
      });
    };

    killHorizontal();
    setTimeout(killHorizontal, 150);
    setTimeout(killHorizontal, 600);
  }

  // ✅ Tek görsel + ortalama
  function applyMainImage(drawer) {
    const scope = getScope(drawer);
    const imgs = getLargeImgs(drawer);
    if (!imgs.length) return null;

    // en büyük olanı seç
    let best = imgs[0];
    let bestScore = 0;
    imgs.forEach((img) => {
      const r = img.getBoundingClientRect();
      const score = r.width * r.height;
      if (score > bestScore) {
        bestScore = score;
        best = img;
      }
    });

    // class ver
    imgs.forEach((img) => {
      img.classList.remove("qv-main", "qv-hide");
      if (img === best) img.classList.add("qv-main");
      else img.classList.add("qv-hide");
    });

    // stage class’ı: best’in en yakın “media container” parent’ına ver
    const stage =
      best.closest("[data-media-id]") ||
      best.closest(".product-quick-images") ||
      best.parentElement;

    if (stage) stage.classList.add("qv-stage");

    return best;
  }

  function setImgSrc(img, src) {
    if (!img || !src) return;
    img.src = src;
    img.setAttribute("src", src);
    img.removeAttribute("srcset");
    img.removeAttribute("data-srcset");
    img.setAttribute("data-src", src);
  }

  async function sync(reason) {
    const drawer = getDrawer();
    if (!drawer) return;

    lockSlide(drawer);

    // her seferinde tek görsel uygula (kayma/ikili görüntü biter)
    const mainImg = applyMainImage(drawer);
    if (!mainImg) {
      log("main img yok", reason);
      return;
    }

    const variantId = getVariantId(drawer);
    if (!variantId) return;

    try {
      const v = await fetchVariant(variantId);
      const src =
        v?.featured_image?.src ||
        v?.featured_image ||
        v?.image ||
        null;

      if (!src) {
        log("variant image yok (admin varyant görseli bağlı değil olabilir)", { variantId, reason });
        return;
      }

      setImgSrc(mainImg, src);
      // src değişince ölçüler değişebilir → tekrar uygula
      setTimeout(() => applyMainImage(drawer), 50);

    } catch (e) {
      log("sync error", e);
    }
  }

  // variant değişince
  document.addEventListener(
    "change",
    (e) => {
      if (!e.target.closest("variant-selects")) return;
      setTimeout(() => sync("variant change"), 0);
    },
    true
  );

  // drawer açılınca
  const mo = new MutationObserver(() => {
    const drawer = getDrawer();
    if (!drawer) return;
    setTimeout(() => sync("drawer open"), 0);
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();